import { useSelector } from 'react-redux';
import { userSelectors } from '../redux/modules/user';
import { User } from '../common/types/Users';

export const useActiveUser = (): User | undefined =>
  useSelector(userSelectors.selectActiveUser);

export default useActiveUser;
